class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    // Overwrite tidio z-index
    $("#tidio-chat iframe").css("z-index","999");
    
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    setTimeout(() => {
      cloneShippingDelay();
      drawerTranslation();
    }, 2000);
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');

    // Close any modal inside the cart drawer
    var cartModals = document.querySelectorAll(".modal-overlay");
    for (var i = 0; i < cartModals.length; i++) {
      cartModals[i].classList.remove("open")
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


class CartDrawerCsVariants extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.handleVariantClick.bind(this));
  }

  handleVariantClick(e) {
    if (e.target.classList.contains('cs-variant-option')) {
      const variantId = e.target.dataset.id;
      const atcElement = this.parentElement.parentElement.querySelector('cart-add-cross-sell.cs-addToCart');

      const variantOptionElements = this.querySelectorAll('.cs-variant-option');
      variantOptionElements.forEach(option => option.classList.remove('active'));

      e.target.classList.add('active');
      this.setIdToAtc(atcElement, variantId)
    }
  }

  setIdToAtc(atcElement, variantId) {
    atcElement.dataset.variantId = variantId
  }
}

customElements.define('cs-variants', CartDrawerCsVariants);


function cloneShippingDelay() {
  let shippingDelay = document.querySelector('.delivery-widget__container .msg__container p');
  if (shippingDelay) {
    let originalShippingDelay = shippingDelay.textContent || shippingDelay.innerText;
    originalShippingDelay = originalShippingDelay.trim()
    let shippingCartCloneElemement = document.getElementById('shippingCart');
    if (!shippingCartCloneElemement) {return;}
    if (originalShippingDelay && originalShippingDelay != '') {
  
      let dateMatch = originalShippingDelay.match(/\d{2} \p{L}+ - \d{2} \p{L}+$/u);
      if (dateMatch) {
        let dateText = dateMatch[0];
        shippingCartCloneElemement.innerHTML = `(${dateText})`;
      } else {
        shippingCartCloneElemement.innerHTML = shippingDelay.innerHTML;
      }
    } else {
      shippingCartCloneElemement.innerHTML = "";
    }
  }
  
}

function drawerTranslation() {
  const storeLang = Shopify.locale;
  
  const sizeElements = document.querySelectorAll('.tpo_cart-properties-wrapper .product-option dt');
  sizeElements.forEach(sizeElement => {
    if (sizeElement.textContent.trim() == "Taille du haut:") {
      if (storeLang == 'es') {
        sizeElement.textContent = "Talla del top:"
      }
    } else if (sizeElement.textContent.trim() == "Taille du bas:") {
      if (storeLang == 'es') {
        sizeElement.textContent = "Talla del bottom:"
      }
    }
  });

  if (storeLang == 'es') {
    const discountElements = document.querySelectorAll('.footer-row .discounts .discounts__discount span');
    discountElements.forEach(discountElement => {
      if (discountElement.textContent.trim() == "EXTRA -20€ EN CADEAU") {
        discountElement.textContent = 'EXTRA -20€ DE REGALO'
      }
    });
  }
  
}

